import angular from 'angular';
import infiniteScrollComponent from './infiniteScroll.component';

let infiniteScrollModule = angular.module('infiniteScroll', []).directive('infiniteScroll', infiniteScrollComponent);

export default infiniteScrollModule;



// WEBPACK FOOTER //
// ./app/common/infiniteScroll/infiniteScroll.js